import React from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import Header from "../Header/Header.jsx"
import Bridge from "../../../services/Bridge.js"
import style from "./style.module.css";

const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,16}$/;
const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

const Login = ({ handleAuth, auth, user }) => {

    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();

    const bridge = new Bridge();

    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");

    React.useEffect(()  => {
        if (auth) navigate("/minecraft");

    // eslint-disable-next-line
	}, []);

    const handleLogin = async () => {

        const v1 = USERNAME_REGEX.test(username);
        const v2 = PASSWORD_REGEX.test(password);

        if (!v1) {
            enqueueSnackbar("Wrong username form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v2) {
            enqueueSnackbar("Wrong password form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        try {
            await bridge.POST("login", {
                username: username,
                password: password
            });

            enqueueSnackbar("Successfully logged in", {
              variant: "success",
              autoHideDuration: 3000,
              onEntered: () => {
                handleAuth();
                navigate("/minecraft");
              }
            });

        } catch (error) {
            enqueueSnackbar(error, {
              variant: "error",
              autoHideDuration: 5000,
            });
        };
    };

    return (
        <>
            <Header />
            <div className={style.rootDiv}>
                <div className={style.person}>
                    <svg viewBox="0 0 448 512">
                        <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/>
                    </svg>
                </div>
                <div className={style.loginBox}>
                    <div></div>
                    <div className={style.inputBox}>
                        <svg viewBox="0 0 448 512">
                            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/>
                        </svg>
                        <input placeholder="In-game Username" value={username} onChange={event => setUsername(event.target.value)}/>
                    </div>
                    <div className={style.inputBox}>
                        <svg viewBox="0 0 512 512">
                            <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"/>
                        </svg>
                        <input placeholder="Password" type="password" value={password} onChange={event => setPassword(event.target.value)}/>
                    </div>
                    <p onClick={() => navigate("/minecraft/register")}>Create Account</p>
                </div>
                <button onClick={handleLogin} className={style.loginBtn}>Login</button>
            </div>
        </>
    );
};

export default Login;